import { SecondaryLeftImageRightTextImageType } from "../../types/mainModulTypes"
import { API } from "../../constants/constants"
import BaseRichtext from "../common/BaseRichtext"
import BaseSubheadline from "../common/BaseSubheadline"

export default function SecondaryLeftImageRightTextImage(props: SecondaryLeftImageRightTextImageType) {
    return (
        <div className="max-w-content mx-auto flex flex-col md:flex-row gap-6 md:gap-8 px-4 lg:px-0">
            <img
                src={API + props?.secondaryLeftImageRightTextImageLeft?.url}
                alt={props.secondaryLeftImageRightTextImageLeft?.description ?? props.secondaryLeftImageRightTextImageLeft?.name}
                className=" md:w-[calc(50%-1rem)] aspect-[6/4] object-cover rounded-default border-4 border-accent"
            />
            <div className="md:w-[calc(50%-1rem)] flex flex-col justify-between border-x-4 border-transparent">
                <div className="flex flex-col pb-6 ">
                    <img
                        src={API + props?.secondaryLeftImageRightTextImageIcon?.url}
                        alt={props.secondaryLeftImageRightTextImageIcon?.description ?? props.secondaryLeftImageRightTextImageIcon?.name}
                        className="w-24 object-contain self-end pb-4 hidden md:block"
                    />
                    <BaseSubheadline label={props.secondaryLeftImageRightTextImageHeading} classProps="pb-2 md:pb-4" />
                    <BaseRichtext content={props?.secondaryLeftImageRightTextImageText} />
                </div>
                <img
                    src={API + props?.secondaryLeftImageRightTextImageRight?.url}
                    alt={props.secondaryLeftImageRightTextImageRight?.description ?? props.secondaryLeftImageRightTextImageRight?.name}
                    className="w-full h-56 rounded-default border-4 border-accent object-cover"
                />
            </div>
        </div>
    )
}
